import cn from "classnames"
import { useRef } from "react"

import { Form, Text } from "@/atoms"
import { DynamicTagsField } from "./DynamicTagsField"
import { getInnerText, replaceKeysWithExamples } from "./helpers"

import styles from "./DynamicTagsField.module.scss"

import type { DynamicTagsFormItemProps } from "."

export const DynamicTagsFormItem = (props: DynamicTagsFormItemProps) => {
  const { name, label, initialValue, tags, form, rules, type } = props
  const { previewMode, disabled, classes = {} } = props
  const onlyPreviewMode = previewMode && !disabled
  const previewDisabled = disabled || previewMode
  const getPreviewValue = () =>
    replaceKeysWithExamples(form.getFieldValue(name), tags || []) || ""
  const initialValueRef = useRef<string>()

  if (initialValueRef.current === undefined)
    initialValueRef.current = initialValue || form.getFieldValue(name) || ""

  return (
    <>
      {onlyPreviewMode && (
        <div
          className={classes.preview}
          dangerouslySetInnerHTML={{ __html: getPreviewValue() }}
        />
      )}
      <div
        data-id={`${name}-dynamic-tags-field`}
        className={cn(
          styles.itemForm,
          onlyPreviewMode && styles.displayNone,
          disabled && styles.disabled
        )}
      >
        <Form.Item name={name} className={styles.displayNone} rules={rules} />
        <Text className={styles.label}>{label}</Text>
        <div className={cn(previewDisabled && styles.displayNone)}>
          <DynamicTagsField
            previewMode={previewMode}
            disabled={disabled}
            tags={tags}
            type={type}
            html={initialValueRef.current || ""}
            onChange={(html: string, text: string) => {
              form.setFieldValue(name, type === "input" ? text : html)
            }}
          />
        </div>
        {previewDisabled && (
          <DynamicTagsField
            previewMode={previewMode}
            disabled={disabled}
            type={type}
            html={getInnerText(getPreviewValue())}
            onChange={() => {}}
          />
        )}
      </div>
    </>
  )
}
